import { useEffect } from 'react';
import { trackEvent, trackPageView } from '../utils/gtm';

/**
 * Custom hook for GTM tracking in React components
 */
export const useGTMTracking = () => {
  return {
    trackEvent,
    trackPageView,
  };
};

/**
 * Hook to track page views on route changes
 * @param path - Current route path
 * @param title - Page title (optional)
 */
export const usePageView = (path: string, title?: string) => {
  useEffect(() => {
    trackPageView(path, title);
  }, [path, title]);
};
